import {Checkbox, Col, Form, Input, Row, Upload} from "antd";
import {EmptyImg, gutter, Modal, MyForm} from "@/theme";
import {useApiMutation} from "@/lib/hook";
import {deleteNullValueInObject} from "@/lib/utils";
import {useEffect, useState} from "react";
import dynamic from "next/dynamic";
import "react-quill/dist/quill.snow.css";

const ReactQuill = dynamic(() => import("react-quill"), {ssr: false});

const QuillEditor = ({value, onChange}) => {
    const modules = {
        toolbar: [
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            ['bold', 'italic', 'underline'],
            [{'align': []}],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['link'],
            ['clean']
        ],
    }

    return (
        <ReactQuill
            theme="snow"
            value={value}
            onChange={onChange}
            modules={modules}
            style={{height: 150, marginBottom: 40}}
            placeholder={'Enter text'}
        />
    );
};

export const NewsCreateModal = ({isModalOpen, setIsModalOpen, refetch, catNip}) => {
    const [form] = Form.useForm();
    const [mainImg, setMainImg] = useState(null);
    const [previewImg, setPreviewImg] = useState(null);
    const [files, setFiles] = useState({});

    const resetFormData = () => {
        form.resetFields();

        // Очистить blob ссылки
        if (mainImg?.startsWith("blob:")) {
            URL.revokeObjectURL(mainImg);
        }
        if (previewImg?.startsWith("blob:")) {
            URL.revokeObjectURL(previewImg);
        }

        setMainImg(null);
        setPreviewImg(null);
        setFiles({});
    };


    const update = useApiMutation({
        onSuccess: () => {
            refetch();
            setIsModalOpen();
            resetFormData();
        },
    });

    useEffect(() => {
        return () => {
            if (mainImg && mainImg?.startsWith("blob:")) {
                URL.revokeObjectURL(mainImg);
            }
            if (previewImg && previewImg?.startsWith("blob:")) {
                URL.revokeObjectURL(previewImg);
            }
        };
    }, [mainImg, previewImg]);

    const onFinish = () => {
        update.mutate({
            route: {name: "catnip.news.create"},
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: {
                ...deleteNullValueInObject(form.getFieldsValue()),
                ...files
            },
        });
    };

    const handleUpload = (field) => (options) => {
        const {file, onSuccess, onError} = options;

        try {
            if (!file.type.startsWith("image/")) {
                onError("Only image files are allowed.");
                return;
            }
            const url = URL.createObjectURL(file);

            if (field === "file") {
                setMainImg(url);
            } else if (field === "file_preview") {
                setPreviewImg(url);
            }

            setFiles(prev => ({...prev, [field]: file}));

            onSuccess(null);
        } catch (error) {
            console.error("Upload failed:", error);
            onError(error);
        }
    };

    const propsMain = {
        name: 'file',
        accept: "image/*",
        showUploadList: false,
        customRequest: handleUpload("file")
    }

    const propsPreview = {
        name: 'file',
        accept: "image/*",
        showUploadList: false,
        customRequest: handleUpload("file_preview")
    }

    return (
        <Modal
            className="news-modal"
            open={isModalOpen}
            onCancel={() => {
                setIsModalOpen(false);
                resetFormData();
            }}
            centered
            destroyOnClose={true}
            title={
                <>
                    <div style={{fontWeight: "bold"}}>{catNip?.title}</div>
                    <div style={{fontWeight: 500}}>{catNip?.sub_title}</div>
                </>
            }
            footer={
                <Modal.Buttons
                    okText="Add new article"
                    cancelText="Cancel"
                    onOk={onFinish}
                    onCancel={setIsModalOpen}
                    okProps={{loading: update.isLoading}}
                />
            }
            width={776}
        >
            <MyForm
                spinning={update.isLoading}
                form={form}
                name="newsCreate"
                autoComplete="off"
                layout="vertical"
            >

                <Row gutter={gutter}>
                    <Col span={24} className={'block_images'}>
                        <div className={'block_main_img'}>
                            {mainImg ?
                                <img src={mainImg} alt="main-img"/>
                                :
                                <div className={'empty_img'}>
                                    <EmptyImg/>
                                </div>
                            }
                            <div className={'info'}>
                                <span>Upload main image<br/>(for full article, 1200×600 px)</span>
                                <Upload {...propsMain}>
                                    <div className={'upload'}>Upload</div>
                                </Upload>
                            </div>
                        </div>

                        <div className={'block_preview_img'}>
                            {previewImg ? <img src={previewImg} alt="preview-img"/>
                                :
                                <div className={'empty_img'}>
                                    <EmptyImg/>
                                </div>
                            }
                            <div className={'info'}>
                                <span>Upload preview image<br/>(for sidebar, 300×180 px)</span>
                                <Upload {...propsPreview}>
                                    <div className={'upload'}>Upload</div>
                                </Upload>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row gutter={gutter}>
                    <Col md={12} xs={24}>
                        <Form.Item name="title" label="Title">
                            <Input placeholder={"Enter text field"}/>
                        </Form.Item>
                    </Col>
                    <Col md={12} xs={24}>
                        <Form.Item name="author" label="Author">
                            <Input placeholder={"Enter author, name etc"}/>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={gutter}>
                    <Col span={24}>
                        <Form.Item
                            name="text"
                            label="Text"
                            valuePropName="value"
                            trigger="onChange"
                            getValueFromEvent={(content) => content}
                            className="quill-container"
                        >
                            <QuillEditor/>
                        </Form.Item>
                    </Col>
                </Row>


                <Row gutter={gutter}>
                    <Col span={24} style={{marginBottom: 10}}>
                        <Form.Item name="is_active_redirect_btn" valuePropName="checked" noStyle>
                            <Checkbox>Add redirect button</Checkbox>
                        </Form.Item>

                        {/*<Form.Item name="is_active_redirect_btn" valuePropName="checked" noStyle>*/}
                        {/*    <Checkbox*/}
                        {/*        onChange={(e) => {*/}
                        {/*            form.setFieldsValue({is_active_redirect_btn: e.target.checked})*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        Add redirect button*/}
                        {/*    </Checkbox>*/}
                        {/*</Form.Item>*/}
                    </Col>
                </Row>

                <Form.Item noStyle shouldUpdate={(prev, curr) =>
                    prev.is_active_redirect_btn !== curr.is_active_redirect_btn
                }>
                    {({getFieldValue}) =>
                        getFieldValue("is_active_redirect_btn") ? (
                            <Row gutter={gutter}>
                                <Col md={12} xs={24}>
                                    <Form.Item name="btn_name" label="Button name">
                                        <Input placeholder={'Add button name'}/>
                                    </Form.Item>
                                </Col>
                                <Col md={12} xs={24}>
                                    <Form.Item name="btn_link" label="URL">
                                        <Input placeholder={'Enter URL'}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        ) : null
                    }
                </Form.Item>
            </MyForm>
        </Modal>
    );
};
